<style lang="scss">
    .useQuse {
        width: 100%;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.20);
        float: right;
        margin-top: 10px;
        padding: 5px;
        @media (min-width: 992px) {
                width: 620px;
                margin: 21px 10px 0 0;
                padding: 40px 38px;
        }
        @media (min-width: 1200px) {
                width: 820px;
        }
        .quse{
            padding-left: 20px;
            background-image: url(../../assets/images/quesion.png);
            background-repeat: no-repeat;
        }
        .answer{
            padding-left: 20px;
            background-image: url(../../assets/images/answer.png);
            background-repeat: no-repeat;
            font-size: 12px;
            color: #999999;
            margin-top: 10px;
        }
        .line{
            border: 2px solid #eeeeee;
            margin:20px 0;
        }
        .phone{
            text-align: right;
            font-size: 12px;
            color: #999999;
        }
    }


</style>
<template>
    <div>
        <ata-side-bar activeIndex="4" class="hidden-xs hidden-sm"></ata-side-bar>
        <div class="useQuse" v-if="exam_type!='1'">
            <div class="quse">考生如何完成注册？</div>
            <div class="answer">登录页面点击“马上注册”，完成注册信息填写即可注册成功；
                若考生忘记登录密码，可在登录页面使用“手机快捷登录”方式验证登录。</div>
            <div class="line"></div>
            <div class="quse">考生如何完成报考？</div>
            <div class="answer">考生使用已注册账号、手机号，输入正确密码可直接登录，点击“报名考试”
                按照报名流程输入正确信息即可完成报考。</div>
            <div class="line"></div>
            <div class="quse">考生如何获取考试相关通知及安排？</div>
            <div class="answer">考生可在报名首页“考试通知”列表查看最新考试信息，紧急通知主办方将根
                据实际情况使用手机短信或发送邮件方式通知考生。</div>
            <div class="line"></div>
            <!--<div class="quse">考生报考完成如何修改个人报考信息？</div>-->
            <!--<div class="answer">考生报考完成不可自己再次修改报考信息，若要变更请联系客服并提供有-->
                <!--效身份证明方可修改。</div>-->
            <!--<div class="line"></div>-->
            <!--<div class="quse">考生报名缴费出现重复支付如何处理？</div>-->
            <!--<div class="answer"> 考生报考发现重复支付的情况，请耐心等待，主办方在核账结束后执行-->
                <!--退款操作，届时会返还金额（根据支付方式不同收取一定比例手续费）。</div>-->
            <!--<div class="line"></div>-->
        </div>
        <div class="useQuse" v-if="exam_type!='2'">
            <div class="quse">预约过程中是否可以修改个人报考信息？</div>
            <div class="answer">考生预约过程中不可对报考信息进行修改。</div>
            <div class="line"></div>
            <div class="quse">登录密码忘记后如何找回密码？</div>
            <div class="answer">考生首次登录默认密码由主办方提供。</div>
            <div class="line"></div>
            <div class="quse">预约完成后是否可以更改预约信息？</div>
            <div class="answer">预约时间内且准考证打印前，您可以修改自己的预约考站信息。如果过了预约时间或者已完成准考证打印，预约信息都将不得更改。</div>
            <div class="line"></div>
            <!--<div class="quse">考生报考完成如何修改个人报考信息？</div>-->
            <!--<div class="answer">考生报考完成不可自己再次修改报考信息，若要变更请联系客服并提供有-->
            <!--效身份证明方可修改。</div>-->
            <!--<div class="line"></div>-->
            <!--<div class="quse">考生报名缴费出现重复支付如何处理？</div>-->
            <!--<div class="answer"> 考生报考发现重复支付的情况，请耐心等待，主办方在核账结束后执行-->
            <!--退款操作，届时会返还金额（根据支付方式不同收取一定比例手续费）。</div>-->
            <!--<div class="line"></div>-->
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {

        data() {
            return {
                Form: {username: ''},
                right_circle: false
            }
        },
        computed: {
            exam_type: {
                get(){
                    return this.$store.state.examInfo.currentExamInfo.exam_type;
                }
            }
        },
        created: function () {
            this.$store.commit('setHeaderState','0');
        }
    }
</script>

